export default {"src":"/_next/static/media/coinWithChart_24.b1ca04d5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};